export enum EPaymentMethods {
  // Response payment methods
  BLIK = 'ABL',
  ADYEN_BAN_CONTACT = 'ADB',
  ADYEN_CARD = 'ADN',
  ADYEN_IDEAL = 'AID',
  ADYEN_SWISH = 'ASW',
  ADYEN_TWINT = 'ATW',
  ADYEN_BANCONTACT_MOBILE = 'ABM',
  MB_WAY = 'AMB',
  APPLE_PAY = 'APY',
  WORDLINE_BAN_CONTACT = 'BAN',
  BANK_ACCOUNT_TRANSFER = 'BNP',
  ON_DELIVERY = 'DOB',
  PRZELEWY = 'EBN',
  SERVIS_24 = 'GOP',
  GOOGLE_PAY = 'GPY',
  CASH = 'HOT',
  IDEAL = 'IDE',
  KLARNA = 'KLA',
  MOBITO = 'MOB',
  MULTIBANCO = 'MTB',
  PAYPAL_EXPRESS_CHECKOUT = 'PAE',
  INSTANT_BANK_TRANSFER_PAN = 'PAN',
  PAY_PAL = 'PAP',
  CARD_PAYMENT = 'PLK',
  INSTALLMENT_PURCHASE = 'RAT',
  INVOICE = 'REC',
  INSTANT_BANK_TRANSFER_SOF = 'SOF',
  STORE_TO_WEB = 'STW',
  YANDEX_MONEY = 'YDX',
  ADYEN_MOBILEPAY = 'AMP',

  // Calculated payment methods
  PAY_PO = 'PAY_PO',
  GLOBAL_PAYMENTS = 'GLOBAL_PAYMENTS',
}

export enum EPaymentTypes {
  PAY_PO = 'PPO',
  GLOBAL_PAYMENTS = 'GLP',
}

export enum EPaymentState {
  DONE = 0,
  UNPAID = 1,
}
